import XLSX from "xlsx";
import {
  SET_WORKBOOK,
  SET_WORKBOOK_FIX,
  SET_DATA_FILE_IMPORT,
  SAVE_IMPORT,
  EXPORT_EXCEL,
  ADD_COLUMN,
  DELETE_COLUMN,
  ADD_ROW,
  DELETE_ROW,
  UPDATE_CELL,
  SET_HEADERS,
  SET_BODY,
  SET_TABLE,
  VALIDATE_CELLS,
  PARSE_CELLS,
} from 'constants/ActionTypes';

const getNewCell = ({ value = "", readOnly = null, type = "text" } = {}) => {
  const cell = {
    id: Math.random(),
    type,
    value,
    readOnly: false
  };

  // if (readOnly !== null) {
  //   cell.readOnly = readOnly;
  // } else if (
  //   value === "Survey" ||
  //   value === "First Name" ||
  //   value === "Mobile"
  // ) {
  //   cell.readOnly = true;
  // }

  // if (value === "Mobile") {
  //   cell.validate = validateMobileNumber;
  //   cell.parse = parseMobileNumber;
  // }

  return cell;
};

// const validateMobileNumber = number => {
//   try {
//     const phoneNumber = parsePhoneNumber(number, "AU");
//     return phoneNumber.isValid();
//   } catch (error) {
//     return false;
//   }
// };

// const parseMobileNumber = number => {
//   try {
//     const phoneNumber = parsePhoneNumber(number, "AU");
//     return phoneNumber.formatInternational();
//   } catch (error) {
//     return number;
//   }
// };


// workbook = [];
// workbook.push({
//     sheetName: wsname[i],
//     data: data,
//     headers: headers.map((h, i) => getNewCell({ value: h }));,
//     rows: newRows
// });

const INIT_STATE = {
  // headers: [
  //   {
  //     id: 1,
  //     type: "text",
  //     value: "First Name",
  //     readOnly: true
  //   },
  //   {
  //     id: 2,
  //     type: "text",
  //     value: "Mobile",
  //     readOnly: true,
  //     validate: validateMobileNumber,
  //     parse: parseMobileNumber
  //   },
  //   {
  //     id: 3,
  //     type: "text",
  //     value: "Survey",
  //     readOnly: true
  //   }
  // ],

  // headers: [],
  // rows: [],
  workbook: [],
  dataFileImport: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_WORKBOOK: {
      const { bstr } = action;

      // console.log('SET_WORKBOOK bstr', bstr);

      let workbook = [];
      let ws = null;
      let sheetName = null;
      let data = null;

      let type = null;
      let value = null;

      // checking the workbook
      if (bstr === null) {
        return { ...state, workbook }; // reset
      }

      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames;

      for (let i = 0; i < wsname.length; i++) {
        sheetName = wsname[i]
        ws = wb.Sheets[sheetName];
        data = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });

        const headers = data[0]; // first row
        const body = data.slice(1); // 2nd row and so on
        // set headers
        const newHeaders = headers.map((h, i) => getNewCell({ value: h }));
        // set body
        const newRows = body.map(row => {
          const tmp = [];
          for (let i = 0; i < newHeaders.length; i++) {
            // const isSurvey = newHeaders[i].value === "Survey";
            // const type = isSurvey ? "survey" : "text";
            // const value = row[i] || (surveys.length ? surveys[0].name : "");
            // tmp.push(getNewCell({ type, value }));

            // // kalo sheet pertama, dan kolomnya Order Date atau Arrival Date
            // if (sheetName === "SALES ORDER"  && (newHeaders[i] === 5 || newHeaders[i] === 6)) {
            //   type = "date";
            //   value = row[i];
            // }

            type = "text";
            value = row[i];
            tmp.push(getNewCell({ type, value }))
          }
          return tmp;
        });


        workbook.push({
          sheetName: wsname[i],
          data: data,
          headers: newHeaders,
          rows: newRows
        });
      }
      return { ...state, workbook };
    }

    case SET_WORKBOOK_FIX: {
      const { data } = action;
      return { ...state, workbook: data };
    }

    case SET_DATA_FILE_IMPORT: {
      const { data } = action;
      return { ...state, dataFileImport: data };
    }

    case SAVE_IMPORT: {
      // repopulate from workbook[i].headers and workbook[i].rows to workbook[i].data

      const { workbook } = state;
      console.log('workbook', workbook);
      let wb = XLSX.utils.book_new();
      let ws = null;
      let wsname = '';

      // looping sheets
      for (let i = 0; i < workbook.length; i++) {
        // from json headers + rows to be data aoa (array of array)
        // expected output [[1, 2, 3], ...[]] array of array, each array group means one row, and inside it means the column value

        let sheetData = [];
        // headers
        let headers = [];
        let newHeaders = workbook[i].headers.map((h, i) => h.value);
        headers.push(newHeaders);
        let newRows = workbook[i].rows.map(row => {
          const tmp = [];
          for (let i = 0; i < newHeaders.length; i++) {
            tmp.push(row[i].value)
          }
          return tmp;
        })

        sheetData = headers.concat(newRows);

        ws = XLSX.utils.aoa_to_sheet(sheetData);
        wsname = workbook[i].sheetName;
        /* add worksheet to workbook */
        XLSX.utils.book_append_sheet(wb, ws, wsname);
      }

      // let wopts = { bookType:'xlsx', bookSST:false, type:'base64' };
      // let wopts = { bookType:'xlsx', type:'base64' };
      let wopts = { bookType: 'xlsx', type: 'array' };
      var wbout = XLSX.write(wb, wopts);
      // var wbout = XLSX.writeFile(wb, 'test.xlsx', wopts);

      console.log('SAVE_IMPORT', wbout);
      // let file = event.target.files[0];
      const formdata = new FormData();
      // data.append("file", file);

      // formdata.append("file", wbout);

      console.log("Date.now()", Date.now());

      // let file = new File(new Blob([wbout], {type: 'application/octet-stream'}), "test.xlsx", {
      //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //   lastModified: Date.now()
      // });

      let file = new File([wbout], "test.xlsx", {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        lastModified: Date.now()
      });

      console.log('file', file);

      formdata.append('file', file); // <-- server expects `file` to hold name
      // formdata.append('data', wbout); // <-- `data` holds the base64-encoded data

      console.log('formdata', formdata);

      // return formdata;

      return { ...state, dataFileImport: formdata }
    }

    case EXPORT_EXCEL: {
      // repopulate from workbook[i].headers and workbook[i].rows to workbook[i].data

      const { workbook } = state;
      console.log('workbook', workbook);
      let wb = XLSX.utils.book_new();
      let ws = null;
      let wsname = '';

      // looping sheets
      for (let i = 0; i < workbook.length; i++) {
        // from json headers + rows to be data aoa (array of array)
        // expected output [[1, 2, 3], ...[]] array of array, each array group means one row, and inside it means the column value

        let sheetData = [];
        // headers
        let headers = [];
        let newHeaders = workbook[i].headers.map((h, i) => h.value);
        headers.push(newHeaders);
        let newRows = workbook[i].rows.map(row => {
          const tmp = [];
          for (let i = 0; i < newHeaders.length; i++) {
            tmp.push(row[i].value)
          }
          return tmp;
        })

        sheetData = headers.concat(newRows);
        console.log('sheetData', sheetData);

        ws = XLSX.utils.aoa_to_sheet(sheetData);
        wsname = workbook[i].sheetName;
        /* add worksheet to workbook */
        XLSX.utils.book_append_sheet(wb, ws, wsname);
      }

      // let wopts = { bookType:'xlsx', bookSST:false, type:'base64' };
      let wopts = { bookType: 'xlsx', type: 'base64' };
      // var wbout = XLSX.write(wb, wopts);
      var wbout = XLSX.writeFile(wb, 'example-import-so-edited.xlsx', wopts);

      // console.log('SAVE_IMPORT', wbout);
      // // let file = event.target.files[0];
      // const formdata = new FormData();
      // // data.append("file", file);

      // formdata.append("file", wbout);
      // // formdata.append('file', 'test.xlsx'); // <-- server expects `file` to hold name
      // // formdata.append('data', wbout); // <-- `data` holds the base64-encoded data

      // console.log('formdata', formdata);

      return { ...state }
    }

    case ADD_COLUMN:
      const { after } = action;
      const newHeader = getNewCell();
      // add new header cell to existing header row
      const headersLeft = [...state.headers].slice(0, after + 1);
      const headersRight = [...state.headers].slice(after + 1);
      const headers = [...headersLeft, newHeader, ...headersRight];
      // add new column to existing rows
      const rows = state.rows.map(row => {
        const newRowCell = getNewCell();
        const left = [...row].slice(0, after + 1);
        const right = [...row].slice(after + 1);
        const newRow = [...left, newRowCell, ...right];
        return newRow;
      });

      return { ...state, headers, rows };

    case DELETE_COLUMN: {
      const { column = 0 } = action;
      const headersLeft = [...state.headers].slice(0, column);
      const headersRight = [...state.headers].slice(column + 1);
      const headers = [...headersLeft, ...headersRight];

      const rows = state.rows.map(row => {
        const cellsLeft = [...row].slice(0, column);
        const cellsRight = [...row].slice(column + 1);
        return [...cellsLeft, ...cellsRight];
      });

      return {
        ...state,
        headers,
        rows
      };
    }

    case ADD_ROW: {
      const { after = 0 } = action;
      const newColumns = state.headers.map(h => {
        const isSurvey = h.value === "Survey";
        const type = isSurvey ? "survey" : "text";
        const value =
          isSurvey && state.surveys.length === 1 ? state.surveys[0].name : "";
        return getNewCell({ type, value });
      });
      const newRow = [newColumns];
      const rowsBefore = [...state.rows].slice(0, after);
      const rowsAfter = [...state.rows].slice(after);
      const rows = [...rowsBefore, ...newRow, ...rowsAfter];
      return { ...state, rows };
    }

    case DELETE_ROW: {
      const { row } = action;
      const rowsBefore = [...state.rows].slice(0, row);
      const rowsAfter = [...state.rows].slice(row + 1);
      return { ...state, rows: [...rowsBefore, ...rowsAfter] };
    }

    // case UPDATE_CELL: {
    //   const { row, column, value } = action;

    //   // update cell
    //   if (typeof row !== "undefined") {
    //     const rows = JSON.parse(JSON.stringify(state.rows));
    //     rows[row][column].value = value;
    //     // const rows = state.rows.map((r, i) => {
    //     //   return r.map((cell, j) => {
    //     //     if (i === row && j === column) {
    //     //       cell.value = value;
    //     //     }
    //     //     return cell;
    //     //   });
    //     // });
    //     return { ...state, rows };
    //   }

    //   // update header
    //   const headers = state.headers.map((h, i) => {
    //     if (i === column) {
    //       h.value = value;
    //     }
    //     return h;
    //   });
    //   return { ...state, headers };
    // }

    case UPDATE_CELL: {
      const { row, column, value, sheet } = action;
      const { workbook } = state;

      let dataSheet = workbook[sheet].data;
      let headersSheet = workbook[sheet].headers;
      let rowsSheet = workbook[sheet].rows;

      // console.log('row', row);
      // console.log('column', column);
      // console.log('value', value);
      // console.log('sheet', sheet);
      // console.log('dataSheet', dataSheet);
      // console.log('headersSheet', headersSheet);
      // console.log('rowsSheet', rowsSheet);


      if (typeof row !== undefined) {
        // change body
        workbook[sheet].rows[row][column].value = value;
        // const rows = JSON.parse(JSON.stringify(state.rows))
        console.log('UPDATE_CELL workbook', workbook);
        return { ...state, workbook };
      }
      else {
        // change header
        workbook[sheet].headers[column].value = value;
        return { ...state, workbook };
      }
      // return state;
    }

    case SET_TABLE: {
      const { rows } = action;
      const headers = rows[0];
      const body = rows.slice(1);

      // set headers
      const newHeaders = headers.map((h, i) => getNewCell({ value: h }));

      // set body
      const newRows = body.map(row => {
        const { surveys } = state;
        const tmp = [];
        for (let i = 0; i < newHeaders.length; i++) {
          // const isSurvey = newHeaders[i].value === "Survey";
          // const type = isSurvey ? "survey" : "text";
          // const value = row[i] || (surveys.length ? surveys[0].name : "");
          const type = "text";
          const value = row[i];
          tmp.push(getNewCell({ type, value }));
        }
        return tmp;
      });

      return { ...state, headers: newHeaders, rows: newRows };
    }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./reducers/ImportExcel.js